import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartsResponse } from './multiCartMappers'
import qs from 'qs'
import type { MachineContext } from 'typings/app/machineContext'
import { filterVisibleUserCartMultiCarts } from 'lib/userCart/multiCartVisibility'
import { arrayToObject } from 'lib/array/arrayUtils'

type FetchSuccess = paths['/api/carts/multi-carts']['get']['responses']['200']['content']['application/json']
type MultiCartSummariesQuery = Pick<paths['/api/carts/multi-carts']['get']['parameters']['query'], 'checkExistingOnly' | 'includeTripPlanner'> & {
  checkExistingOnly: 'false'
}

function mapMultiCartSummariesToCartSummary(cartSummaries: Array<App.MultiCartSummary>): MachineContext.CartSummary {
  return arrayToObject<App.MultiCartSummary, App.MultiCartSummary, string>(cartSummaries, cart => cart.cartId)
}

export async function getMultiCartSummaries(): Promise<MachineContext.CartSummary> {
  const query: MultiCartSummariesQuery = { checkExistingOnly: 'false' }
  const queryParams = qs.stringify(query)

  const response = await request.get<FetchSuccess>(`/api/carts/multi-carts?${queryParams}`, { credentials: 'include' })
  const cartSummaries = filterVisibleUserCartMultiCarts(mapMultiCartsResponse(response))

  return mapMultiCartSummariesToCartSummary(cartSummaries)
}
